var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model.id!==undefined)?_c('div',{attrs:{"id":"container"}},[_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.model.name))]),_vm._v(" "),_c('div',{staticClass:"padding-10",domProps:{"innerHTML":_vm._s(_vm.model.content)}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-810548bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/inf/article/Model.vue
// module id = null
// module chunks = 